const upcomingAppointments = [
  { service: 'Care visit', client: 'John Appleseed', time: 'Today · 09:00 AM' },
  { service: 'Medication check', client: 'Lina Torres', time: 'Today · 11:30 AM' },
  { service: 'Rehab follow-up', client: 'Maya Patel', time: 'Today · 03:00 PM' },
];

const timeline = [
  { label: '09:00 AM', detail: 'Care visit · confirmed', status: 'confirmed' },
  { label: '12:45 PM', detail: 'Travel time to Saint John', status: 'in-transit' },
  { label: '03:30 PM', detail: 'Rehab follow-up · pending', status: 'pending' },
];

function AppointmentsPage() {
  return (
    <div className="space-y-6">
      <header className="space-y-3">
        <p className="text-xs uppercase tracking-[0.6em] text-emerald-500">Appointments</p>
        <h1 className="text-3xl font-semibold text-slate-900">Active visits & reminders</h1>
        <p className="text-slate-600">
          Keep track of every caregiver engagement for the day and make sure adjustments are published before the next shift.
        </p>
      </header>
      <section className="grid gap-6 md:grid-cols-2">
        {upcomingAppointments.map((appointment) => (
          <article
            key={appointment.time}
            className="rounded-3xl border border-emerald-100 bg-emerald-50/80 px-5 py-6 shadow-lg shadow-emerald-100"
          >
            <p className="text-xs uppercase tracking-[0.4em] text-emerald-600">Upcoming</p>
            <p className="mt-3 text-lg font-semibold text-slate-900">{appointment.service}</p>
            <p className="text-sm text-slate-600">{appointment.client}</p>
            <p className="mt-4 text-sm font-semibold text-emerald-700">{appointment.time}</p>
          </article>
        ))}
      </section>
      <section className="rounded-3xl border border-emerald-100 bg-white p-6 shadow-lg shadow-slate-200">
        <h2 className="text-lg font-semibold text-slate-900">Timeline</h2>
        <ul className="mt-4 space-y-4 text-sm text-slate-600">
          {timeline.map((entry) => (
            <li key={entry.label} className="flex items-center justify-between rounded-2xl border border-emerald-100 px-4 py-3 bg-emerald-50/60">
              <div>
                <p className="text-xs uppercase tracking-[0.5em] text-emerald-500">{entry.label}</p>
                <p className="text-base font-semibold text-slate-900">{entry.detail}</p>
              </div>
              <span
                className={`rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-[0.3em] ${
                  entry.status === 'confirmed'
                    ? 'bg-emerald-200 text-emerald-700'
                    : entry.status === 'in-transit'
                    ? 'bg-amber-100 text-amber-700'
                    : 'bg-slate-100 text-slate-500'
                }`}
              >
                {entry.status.replace('-', ' ')}
              </span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default AppointmentsPage;
